import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaRobot, FaArrowRight } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';

const pulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 rgba(6, 214, 160, 0.55); }
  50%     { box-shadow: 0 0 0 6px rgba(6, 214, 160, 0); }
`;

const Launcher = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 999px;
  border: 1px solid rgba(0, 180, 216, 0.35);
  background:
    linear-gradient(135deg, rgba(0, 180, 216, 0.14), rgba(11, 19, 32, 0.92) 60%),
    rgba(11, 19, 32, 0.92);
  color: var(--text-primary);
  backdrop-filter: blur(10px);
  cursor: pointer;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(0, 180, 216, 0.08);
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, gap 0.18s ease;
  font-family: inherit;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(0, 180, 216, 0.65);
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.5), 0 0 20px rgba(0, 180, 216, 0.18);
  }
`;

const IconWrap = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(0, 180, 216, 0.14);
  color: var(--btn-primary);
  border: 1px solid rgba(0, 180, 216, 0.3);
  flex-shrink: 0;
`;

const StatusDot = styled.span`
  position: absolute;
  top: -1px;
  right: -1px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--alert-success);
  border: 2px solid #0b1320;
  animation: ${pulse} 2.2s ease-in-out infinite;
`;

const LabelWrap = styled.span`
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  text-align: left;
`;

const Label = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary);
  letter-spacing: 0.02em;
`;

const Tag = styled.span`
  font-family: 'JetBrains Mono', 'Consolas', monospace;
  font-size: 0.62rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--btn-primary);
  margin-top: 2px;
`;

const Arrow = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--btn-primary);
  transform: translateX(-4px);
  opacity: 0.65;
  transition: transform 0.18s ease, opacity 0.18s ease;

  ${Launcher}:hover & {
    transform: translateX(0);
    opacity: 1;
  }
`;

const ChatAssistant = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pressed, setPressed] = useState(false);

  if (location.pathname === '/chat') return null;

  const goToChat = () => {
    setPressed(true);
    navigate('/chat');
  };

  return (
    <Launcher type="button" onClick={goToChat} aria-label="Abrir asistente de IA" data-pressed={pressed}>
      <IconWrap>
        <FaRobot size={14} />
        <StatusDot />
      </IconWrap>
      <LabelWrap>
        <Label>Asistente Arcana</Label>
        {/* Antes decía "AI · Online", que no distinguía de nada. Ahora dice para
            qué sirve, que es lo que lo separa del Agente de la plataforma. */}
        <Tag>AI · Respuesta rápida</Tag>
      </LabelWrap>
      <Arrow>
        <FaArrowRight size={11} />
      </Arrow>
    </Launcher>
  );
};

export default ChatAssistant;
